module.exports = __webpack_public_path__ + "static/media/hacker.98faded5.png";